<template>
  <div
    ref="vimeoPlayer"
    :class="[{ 'video-playing': isPlaying }]"
    class="video-container"
  ></div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import Player from "@vimeo/player";

const props = defineProps({
  videoId: {
    type: String,
    required: true,
  },
});
const vimeoPlayer = ref(null);
const isPlaying = ref(false);

onMounted(() => {
  const player = new Player(vimeoPlayer.value, {
    id: props.videoId,
    background: true,
    loop: true,
  });

  player
    .ready()
    .then(() => {
      console.log("Vimeo Player is ready.");
      player.on("play", () => {
        isPlaying.value = true;
      });
    })
    .catch((error) => console.error("Error creating Vimeo player:", error));
});
</script>

<style scoped lang="scss">
.video-container {
  opacity: 0;
  transition: opacity 0.5s;
}

.video-playing {
  opacity: 1;
}
</style>
